import React, { useState } from 'react';
import { Menu, X, Paintbrush } from 'lucide-react';
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Portfolio',
    href: '#portfolio'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className="sticky top-0 z-50 w-full bg-warmWhite/95 backdrop-blur-sm border-b border-warmGray h-[60px] md:h-20 flex items-center transition-all duration-300" data-id="element-82">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between h-full" data-id="element-83">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 text-charcoal hover:text-gold transition-colors" data-id="element-84">
          <Paintbrush className="w-6 h-6 md:w-7 md:h-7 text-gold" data-id="element-85" />
          <span className="font-heading font-bold text-lg md:text-xl tracking-tight" data-id="element-86">
            [Company Name]
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-87">
          <ul className="flex items-center gap-6" data-id="element-88">
            {navLinks.map(link => <li key={link.name} data-id="element-89">
                <a href={link.href} className="text-sm font-medium text-charcoal/80 hover:text-gold transition-colors" data-id="element-90">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <a href="#contact" className="bg-gold text-white px-5 py-2.5 rounded text-sm font-semibold hover:bg-gold/90 transition-colors shadow-sm" data-id="element-91">
            Get a Quote
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2 -mr-2 text-charcoal" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-92">
          {isOpen ? <X className="w-6 h-6" data-id="element-93" /> : <Menu className="w-6 h-6" data-id="element-94" />}
        </button>
      </div>

      {/* Mobile Nav Dropdown */}
      {isOpen && <div className="absolute top-[60px] left-0 w-full bg-warmWhite border-b border-warmGray shadow-lg md:hidden flex flex-col" data-id="element-95">
          <nav className="flex flex-col px-4 py-6 gap-4" data-id="element-96">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium text-charcoal py-2 border-b border-warmGray/50" onClick={() => setIsOpen(false)} data-id="element-97">
                {link.name}
              </a>)}
            <a href="#contact" className="mt-4 bg-gold text-white text-center px-6 py-3.5 rounded font-semibold hover:bg-gold/90 transition-colors w-full" onClick={() => setIsOpen(false)} data-id="element-98">
              Get a Quote
            </a>
          </nav>
        </div>}
    </header>;
}